import React, { useEffect, useState } from "react";
import { Modal } from "react-responsive-modal";
import SellIcon from "@mui/icons-material/Sell";
import CreatableSelect from "react-select/creatable";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../../Context/GlobalContext";
import Cookies from "js-cookie";
import Select from "react-select";

const UpdateLeadModel = ({ open, onCloseModal, selectedItem, callback }) => {
  const [selectedTag, setSelectedTag] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { baseUrl, openToast,fetchLead } = useGlobalContext();
  const [leadname, setLeadName] = useState("");
  const [leadposition, setLeadPosition] = useState("");
  const [leademail, setLeadEmail] = useState("");
  const [leadwebsite, setLeadWebsite] = useState("");
  const [leadphone, setLeadPhone] = useState("");
  const [leadvalue, setLeadValue] = useState([]);
  const [leadcurrencysymbol, setLeadCurrencySymbol] = useState(["₹"]);
  const [leadaddress, setLeadAddress] = useState();
  const [leadcity, setLeadCity] = useState("");
  const [leadstate, setLeadState] = useState("");
  const [leadcountry, setLeadCountry] = useState("");
  const [leadzipCode, setLeadZipCode] = useState("");
  const [leaddefaultLanguage, setLeadDefaultLanguage] = useState([]);
  const [leadcompany, setLeadCompany] = useState("");
  const [leaddescription, setLeadDescription] = useState("");
  const [leadisPublic, setLeadIsPublic] = useState(false);


  

  const handleChange = (selectedOptions) => {
    setSelectedTag([...selectedOptions]);
  };
  const handleChangevalues = (selectedOptions1) => {
    setLeadValue([...selectedOptions1]);
  };

  console.log(leadvalue);
  const handleChangelanguage = (selectedOptions3) => {
    setLeadDefaultLanguage([...selectedOptions3]);
  };

  console.log(leaddefaultLanguage);

  const [values, setValues] = useState([
    { value: "10", label: "10" },
    { value: "20", label: "20" },
    { value: "30", label: "30" },
    { value: "40", label: "40" },
    { value: "50", label: "50" },
  ]);
  const [language, setLanguage] = useState([
    { value: "english", label: "english" },
    { value: "france", label: "france" },
    { value: "hindi", label: "hindi" },
  ]);
  const [tags, setTags] = useState([
    { value: "thumbnail", label: "thumbnail" },
    { value: "youtube", label: "youtube" },
    { value: "youtube thumbnail", label: "youtube thumbnail" },
    { value: "carousel", label: "carousel" },
    { value: "RE-DESIGN", label: "REDESIGN" },
    { value: "Ads", label: "Ads" },
    { value: "drdcrcrc", label: "drdcrcrc" },
  ]);
  console.log(selectedItem);
  async function updateLead() {
    try {
      setIsLoading(true);
  
      const response = await fetch(baseUrl + `lead/${selectedItem?.id}`, {
        method: "PUT",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({
          name: leadname,
          position: leadposition,
          email: leademail,
          website: leadwebsite,
          phone: leadphone,
          leadValue: leadvalue?.map((option) => parseFloat(option.value)) || [],
          currencySymbol: leadcurrencysymbol,
          address: leadaddress,
          city: leadcity,
          state: leadstate,
          country: leadcountry,
          zipCode: leadzipCode,
          defaultLanguage: leaddefaultLanguage?.map((option) => option.value) || [],
          company: leadcompany,
          description: leaddescription,
          isPublic: leadisPublic,
          tags: selectedTag?.map((option) => option.value) || [],
        }),
      });
  
      if (response.ok) {
        openToast("Update Lead Successfully", "success");
        callback();
        onCloseModal();
        fetchLead()
      }
    } catch (error) {
      console.error("Error updating lead:", error);
      openToast("Failed to update lead", "error");
    } finally {
      setIsLoading(false);
    }
  }
  

  useEffect(() => {
    if (selectedItem) {
      setLeadName(selectedItem?.name);
      setLeadPosition(selectedItem?.position);
      setLeadCity(selectedItem?.city);
      setLeadEmail(selectedItem?.email);
      setLeadState(selectedItem?.state);
      setLeadWebsite(selectedItem?.website);
      setLeadCountry(selectedItem?.country);
      setLeadPhone(selectedItem?.phone);
      setLeadZipCode(selectedItem?.zipCode);
      setLeadCompany(selectedItem?.company);
      setLeadAddress(selectedItem?.address);
      setLeadDescription(selectedItem?.description);
      setLeadIsPublic(selectedItem?.leadisPublic);

      // Set default selected tags
      if (selectedItem?.tags) {
        const formattedTags = selectedItem.tags.map((tag) => ({
          value: tag,
          label: tag,
        }));
        setSelectedTag(formattedTags);
      }
      // Set default selected lead values
      if (selectedItem?.leadValue) {
        const formattedLeadValues = selectedItem.leadValue.map((value) => ({
          value: value.toString(),
          label: value.toString(),
        }));
        setLeadValue(formattedLeadValues);
      }

      // Set default selected languages

      // Set default selected languages
      if (selectedItem?.defaultLanguage) {
        const formattedLanguages = selectedItem.defaultLanguage.map((lang) => ({
          value: lang,
          label: lang,
        }));
        setLeadDefaultLanguage(formattedLanguages);
      }
    }
  }, [selectedItem]);


  return (
    <div>
      <Modal
        open={open}
        onClose={() => onCloseModal()}
        center
        classNames={{
          modal:
            "w-full max-w-lg lg:max-w-4xl mx-auto rounded-lg overflow-hidden",
        }}
      >
        <h2 className="mb-4 font-medium text-[18px]">Update Lead</h2>
        <div className="max-h-[80vh] overflow-y-auto">
          <div className="">
            <div className="mt-[10px]">
              <label className="block mb-1 font-medium text-gray-700 text-sm">
                Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                onChange={(e) => setLeadName(e.target.value)}
                className="border-[#DBDCDE] focus:shadow-cs px-2 py-1 border rounded-md w-full focus:outline-none"
                value={leadname}
              />
            </div>
            <div className="mt-[10px]">
              <label className="block mb-1 font-medium text-gray-700 text-sm">
                Position
              </label>
              <input
                type="text"
                onChange={(e) => setLeadPosition(e.target.value)}
                className="border-[#DBDCDE] focus:shadow-cs px-2 py-1 border rounded-md w-full focus:outline-none"
                value={leadposition}
              />
            </div>
            <div className="mt-[10px]">
              <label className="block mb-1 font-medium text-gray-700 text-sm">
                City
              </label>
              <input
                type="text"
                onChange={(e) => setLeadCity(e.target.value)}
                className="border-[#DBDCDE] focus:shadow-cs px-2 py-1 border rounded-md w-full focus:outline-none"
                value={leadcity}
              />
            </div>
            <div className="mt-[10px]">
              <label className="block mb-1 font-medium text-gray-700 text-sm">
                Email
              </label>
              <input
                type="email"
                onChange={(e) => setLeadEmail(e.target.value)}
                className="border-[#DBDCDE] focus:shadow-cs px-2 py-1 border rounded-md w-full focus:outline-none"
                value={leademail}
              />
            </div>
            <div className="mt-[10px]">
              <label className="block mb-1 font-medium text-gray-700 text-sm">
                State
              </label>
              <input
                type="text"
                onChange={(e) => setLeadState(e.target.value)}
                className="border-[#DBDCDE] focus:shadow-cs px-2 py-1 border rounded-md w-full focus:outline-none"
                value={leadstate}
              />
            </div>
            <div className="mt-[10px]">
              <label className="block mb-1 font-medium text-gray-700 text-sm">
                Website
              </label>
              <input
                type="url"
                onChange={(e) => setLeadWebsite(e.target.value)}
                className="border-[#DBDCDE] focus:shadow-md px-2 py-1 border rounded-md w-full focus:outline-none"
                value={leadwebsite}
              />
            </div>
            <div className="mt-[10px]">
              <label className="block mb-1 font-medium text-gray-700 text-sm">
                Country
              </label>
              <input
                type="text"
                onChange={(e) => setLeadCountry(e.target.value)}
                className="border-[#DBDCDE] focus:shadow-cs px-2 py-1 border rounded-md w-full focus:outline-none"
                value={leadcountry}
              />
            </div>
            <div className="mt-[10px]">
              <label className="block mb-1 font-medium text-gray-700 text-sm">
                Phone
              </label>
              <input
                type="tel"
                onChange={(e) => setLeadPhone(e.target.value)}
                className="border-[#DBDCDE] focus:shadow-cs px-2 py-1 border rounded-md w-full focus:outline-none"
                value={leadphone}
              />
            </div>
            <div className="mt-[10px]">
              <label className="block mb-1 font-medium text-gray-700 text-sm">
                Zip Code
              </label>
              <input
                type="text"
                onChange={(e) => setLeadZipCode(e.target.value)}
                className="border-[#DBDCDE] focus:shadow-cs px-2 py-1 border rounded-md w-full focus:outline-none"
                value={leadzipCode}
              />
            </div>

            <div className="mt-[6px] mb-[10px]">
              <label className="font-medium text-gray-700 text-sm">
                Lead Value
              </label>
              <br />
              <CreatableSelect
                isMulti
                options={values}
                value={leadvalue}
                onChange={handleChangevalues}
                placeholder="Select or add value..."
                className="w-full tag-selector"
                styles={{
                  control: (provided) => ({
                    ...provided,
                    minHeight: "35px",
                    border: "1px solid #d1d5db",
                  }),
                  multiValue: (provided) => ({
                    ...provided,
                    backgroundColor: "#e5e7eb",
                    borderRadius: "4px",
                  }),
                  multiValueLabel: (provided) => ({
                    ...provided,
                    fontSize: "0.875rem",
                  }),
                  multiValueRemove: (provided) => ({
                    ...provided,
                    color: "#4b5563",
                    cursor: "pointer",
                  }),
                }}
                required
              />
            </div>
            <div className="inline-block relative mb-[6px] w-[100%] text-left">
              <label
                htmlFor="currencySymbol"
                className="block font-medium text-gray-700 text-sm"
              >
                currency
              </label>
              <Select
                name="currencySymbol"
                closeMenuOnSelect={false}
                isMulti
                defaultValue={[{ label: "INR", value: "₹" }]}
                onChange={(o) => {
                  const arr = o.map((op) => op.value);
                  setLeadCurrencySymbol(arr);
                }}
                options={[
                  { label: "USD", value: "$" },
                  { label: "INR", value: "₹" },
                ]}
              />
            </div>
            <div className="mt-[6px]">
              <label className="font-medium text-gray-700 text-sm">
                Default Language
              </label>
              <br />
              <CreatableSelect
                isMulti
                options={language}
                value={leaddefaultLanguage} // Set default value
                onChange={handleChangelanguage}
                placeholder="Select or add language..."
                className="w-full tag-selector"
                styles={{
                  control: (provided) => ({
                    ...provided,
                    minHeight: "35px",
                    border: "1px solid #d1d5db",
                  }),
                  multiValue: (provided) => ({
                    ...provided,
                    backgroundColor: "#e5e7eb",
                    borderRadius: "4px",
                  }),
                  multiValueLabel: (provided) => ({
                    ...provided,
                    fontSize: "0.875rem",
                  }),
                  multiValueRemove: (provided) => ({
                    ...provided,
                    color: "#4b5563",
                    cursor: "pointer",
                  }),
                }}
                required
              />
            </div>
            <div className="mt-[10px]">
              <label className="block mb-1 font-medium text-gray-700 text-sm">
                Company
              </label>
              <input
                type="text"
                onChange={(e) => setLeadCompany(e.target.value)}
                className="border-[#DBDCDE] focus:shadow-cs px-2 py-1 border rounded-md w-full focus:outline-none"
                value={leadcompany}
              />
            </div>
            <div className="mt-[10px]">
              <label className="block mb-1 font-medium text-gray-700 text-sm">
                Tags
              </label>
              <div className="flex items-center gap-[10px]">
                <SellIcon />
                <CreatableSelect
                  isMulti
                  options={tags}
                  onChange={handleChange}
                  value={selectedTag} // Bind selectedTag to the input field
                  placeholder="Select or add tags..."
                  className="w-full tag-selector"
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      minHeight: "35px",
                      border: "1px solid #d1d5db",
                    }),
                    multiValue: (provided) => ({
                      ...provided,
                      backgroundColor: "#e5e7eb",
                      borderRadius: "4px",
                    }),
                    multiValueLabel: (provided) => ({
                      ...provided,
                      fontSize: "0.875rem",
                    }),
                    multiValueRemove: (provided) => ({
                      ...provided,
                      color: "#4b5563",
                      cursor: "pointer",
                    }),
                  }}
                  required
                />
              </div>
            </div>
          </div>
          <div className="mt-[10px]">
            <label className="block mb-1 font-medium text-gray-700 text-sm">
              Address
            </label>
            <textarea
              onChange={(e) => setLeadAddress(e.target.value)}
              rows={3}
              className="border-[#DBDCDE] focus:shadow-cs px-2 py-1 border rounded-md w-full focus:outline-none"
              value={leadaddress}
            />
          </div>
          <div className="mt-[10px]">
            <label className="block mb-1 font-medium text-gray-700 text-sm">
              Description
            </label>
            <textarea
              onChange={(e) => setLeadDescription(e.target.value)}
              rows={3}
              className="border-[#DBDCDE] focus:shadow-cs px-2 py-1 border rounded-md w-full focus:outline-none"
              value={leaddescription}
            />
          </div>
          <div className="flex items-center gap-[10px] mt-[6px]">
            <input
              type="checkbox"
              value={leadisPublic}
              onChange={(e) => setLeadIsPublic(e.target.checked)}
            />
            <p>Public</p>
          </div>

          <div className="flex justify-end gap-4 mt-6">
            <button
              className={`second-btn pt-2 py-2 pl-5 pr-5 rounded-md text-gray-600 bg-gray-200 hover:bg-gray-300`}
              onClick={onCloseModal}
            >
              Cancel
            </button>
            <button
              className={`second-btn ${
                isLoading == true ? "opacity-50 cursor-not-allowed" : ""
              }`}
              onClick={updateLead}
            >
              Update
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default UpdateLeadModel;